module.exports = __webpack_public_path__ + "static/media/fly0225.b6b75709.webp";